import * as React from "react";

function Header() {
  return null as any;
}
export default Header;
